{
    "Accessibility Menu": "Menu de Acessibilidade",
    "Reset settings": "Redefinir configurações",
    "Close": "Fechar",
    "Content Adjustments": "Ajustes de Conteúdo",
    "Adjust Font Size": "Ajustar Tamanho da Fonte",
    "Highlight Title": "Destacar Título",
    "Highlight Links": "Destacar Links",
    "Readable Font": "Fonte Legível",
    "Color Adjustments": "Ajustes de Cor",
    "Dark Contrast": "Contraste Escuro",
    "Light Contrast": "Contraste Claro",
    "High Contrast": "Alto Contraste",
    "High Saturation": "Saturação Alta",
    "Low Saturation": "Saturação Baixa",
    "Monochrome": "Monocromático",
    "Protanopia": "Protanopia",
    "Deuteranopia": "Deuteranopia",
    "Tritanopia": "Tritanopia",
    "Visual & Navigation Aids": "Auxiliares Visuais e de Navegação",
    "Additional Tools": "Ferramentas Adicionais",
    "Reading Guide": "Guia de Leitura",
    "Stop Animations": "Parar Animações",
    "Big Cursor": "Cursor Grande",
    "Screen Reader": "Leitor de Tela",
    "Hide Images": "Ocultar Imagens",
    "Image Tooltips": "Dicas de Imagens",
    "Page Structure": "Estrutura da Página",
    "Super Focus": "Super Foco",
    "Magnifier": "Lupa",
    "Increase Font Size": "Aumentar Tamanho da Fonte",
    "Decrease Font Size": "Diminuir Tamanho da Fonte",
    "Letter Spacing": "Espaçamento entre Letras",
    "Line Height": "Altura da Linha",
    "Font Weight": "Espessura da Fonte",
    "Dyslexia Font": "Fonte para Dislexia",
    "Language": "Idioma",
    "Open Accessibility Menu": "Abrir menu de acessibilidade",
    "Accessibility Profiles": "Perfis de Acessibilidade",
    "Seizure Safe Profile": "Perfil Seguro para Crises",
    "Stops animations and reduces color saturation.": "Para animações e reduz a saturação de cores.",
    "Blind Profile": "Perfil para Cegos",
    "Activates the screen reader for auditory navigation.": "Ativa o leitor de tela para navegação auditiva.",
    "Visually Impaired Profile": "Perfil para Deficientes Visuais",
    "Enhances contrast and readability for low vision.": "Melhora o contraste e a legibilidade para baixa visão.",
    "ADHD Friendly Profile": "Perfil Amigável para TDAH",
    "Reduces distractions for better focus.": "Reduz distrações para melhor concentração.",
    "Cognitive & Learning Profile": "Perfil Cognitivo e de Aprendizagem",
    "Helpful tools for reading and comprehension.": "Ferramentas úteis para leitura e compreensão.",
    "Motor Impaired Profile": "Perfil para Deficiência Motora",
    "Optimizes the site for keyboard-only navigation.": "Otimiza o site para navegação apenas por teclado.",
    "Headings": "Títulos",
    "Landmarks": "Marcos",
    "Links": "Links",
    "Focus element": "Focar elemento",
    "Visit link": "Visitar link"
}